
import { defineStore } from 'pinia'
import { localLogin } from '@/api/authApi'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        status: 'authenticating',
        user: null,
        idToken: null,
        refreshToken: null,
    }),

    getters: {
        currentState: (state) => state.status,
        username: (state) => state.user?.name || '',
    },

    actions: {
        loginUser({ user, idToken, refreshToken }) {
            if (idToken) {
                localStorage.setItem('idToken', idToken)
                this.idToken = idToken
            }
            if (refreshToken) {
                localStorage.setItem('refreshToken', refreshToken)
                this.refreshToken = refreshToken
            }
            this.user = user
            this.status = 'authenticated'
        },

        logout() {
            this.user = null
            this.idToken = null
            this.refreshToken = null
            this.status = 'not-authenticated'
            localStorage.removeItem('idToken')
            localStorage.removeItem('refreshToken')
        },

        async createUser(user) {
            const { email, password } = user
            try {
                const { data } = await localLogin(email, password)
                const { idToken, refreshToken, status } = data
                if (status) {
                    delete user.password
                    this.loginUser({ user, idToken, refreshToken })
                    return { ok: true }
                } else {
                    return { ok: false, message: 'Error logueo' }
                }
            } catch (error) {
                return { ok: false, message: error.response.data.error.message }
            }
        },

        async signInUser(user) {
            const { email, password } = user
            try {
                const { data } = await localLogin(email, password)
                const { status } = data
                if (status) {
                    const { idToken, refreshToken } = data
                    delete user.password
                    this.loginUser({ user, idToken, refreshToken })
                    return { ok: true }
                } else {
                    return { ok: false, message: 'Error logueo' }
                }
            } catch (error) {
                return { ok: false, message: 'error' }
            }
        },

        async checkAuthentication() {
            const idToken = localStorage.getItem('idToken')
            const refreshToken = localStorage.getItem('refreshToken')

            if (!idToken) {
                this.logout()
                return { ok: false, message: 'No hay token' }
            }

            try {
                const user = {
                    name: 'Game Salomon',
                    email: 'game@salomonhub.com',
                }
                this.loginUser({ user, idToken, refreshToken })
                return { ok: true }
            } catch (error) {
                this.logout()
                return { ok: false, message: error.response.data.error.message }
            }
        },
    },
})
